export default __webpack_public_path__ + "static/media/Pastas.4ebaaf75.jpg";